import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DataSurfacePage } from '../../../features/surface/DataSurfacePage';
import { findMenuItemByLink, findParentPathMenuItem } from '../../../features/menu/helpers';
import { store } from '../../../app/store';
import { menuApi } from '../../../features/menu/api/menuApi';

// Search params schema for state that was previously in location.state
const detailSearchSchema = z.object({
  gridContentKey: z.string().optional(),
  detailFormKey: z.string().optional(),
  reviewId: z.string().optional(),
  parentId: z.string().optional(),
});

export const Route = createFileRoute('/_protected/$/add')({
  validateSearch: detailSearchSchema,
  beforeLoad: async ({ location }) => {
    // Extract base path from the URL (remove the 'add' segment)
    const pathname = location.pathname;
    const segments = pathname.split('/').filter(Boolean);
    segments.pop(); // Remove 'add'
    const basePath = '/' + segments.join('/');

    // Get menu items from RTK Query cache
    const state = store.getState();
    const cacheKey = menuApi.endpoints.getMenuItems.select(undefined)(state);
    const menuItems = cacheKey.data || [];

    if (menuItems.length === 0) {
      // Menu not loaded yet - allow navigation to proceed
      return { menuItem: null, basePath, mode: 'add' as const };
    }

    // Find menu item for this page
    let menuItem = findMenuItemByLink(menuItems, basePath);

    // Fallback for child grids
    if (!menuItem) {
      menuItem = findParentPathMenuItem(menuItems, basePath);
    }

    // If no match, allow it anyway (DetailPage will handle the error)
    if (!menuItem) {
      return { menuItem: null, basePath, mode: 'add' as const };
    }

    return { menuItem, basePath, mode: 'add' as const };
  },
  component: DataSurfacePage,
});
